define('pageMeta/pageMeta',['require','exports','module','jquery'],function( require, exports, module ) {
	var $ = require('jquery');

    // iterate over all the meta tags assigning them to exports.
	$('head meta').each(function( i, meta ) {
		var key = meta.getAttribute('name') || meta.getAttribute('property');

		if (key) {
			var overrideKey = 'bam-override-'+key+'=';
			var overrideIndex = window.location.href.indexOf(overrideKey)
			if (overrideIndex !== -1) {
				var overrideVal = window.location.href.substr(overrideIndex+overrideKey.length);
				var nextAmp = overrideVal.indexOf('&');
				if (nextAmp !== -1) {
					overrideVal = overrideVal.substr(0, nextAmp);
				}
				exports[key] = overrideVal
			} else {
				exports[key] = meta.getAttribute('content');
			}
			switch( meta.getAttribute('data-type') ) {
				case 'json':
					exports[key] = JSON.parse(exports[key]);
			}
		}
	});

});
